import { Component, Input } from '@angular/core';
import { Client } from 'src/typings';
import { formatClientPhoneCompact } from '../client-phone.util';

@Component({
  selector: 'app-client-list-item-new',
  templateUrl: './client-list-item-new.component.html',
  styleUrls: ['./client-list-item-new.component.scss']
})
export class ClientListItemNewComponent {
  @Input() client: Client | undefined;

  @Input() even: boolean = false;

  get phoneSummary() {
    return formatClientPhoneCompact(this.client);
  }
}
